module.exports = __webpack_public_path__ + "img/yuyue_line.38445aa4.png";